import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mtop-10"
}

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import EsSelectInstitute from '@/components/settings/esSelectInstitute.vue';
import EsAppointmentTypeSettings from '@/components/settings/esAppointmentTypeSettings.vue'
import EsPlanningSettings from '@/components/settings/esPlanningSettings.vue';
import EsDayModelSettings from '@/components/settings/esDayModelSettings.vue';
import Tabs from '@/components/tabs/tabs.vue';
import Tab from '@/components/tabs/tab.vue';
import { ItemSelect } from '@/models/share.model';
import EsSpecialDaysSettings from '@/components/settings/esSpecialDaysSettings.vue';
import EsCalendarMainSettings from '@/components/settings/esCalendarMainSettings.vue';
import { PersonLightResponse } from '@/apiGenerate/medserver';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAgendaSettings',
  props: {
    hasOwnerAgendaPermission: { type: Boolean, default: false }
  },
  emits: ['refresh-calendar'],
  setup(__props: any, { emit: __emit }) {



const { t } = useI18n();
const duration = ref(0);
const selectedInstitute = ref<ItemSelect>(null);
const selectedHealthPro = ref<PersonLightResponse>(null);
const refreshDataDayModel = ref<boolean>(false);
const refreshDataWeekAndSpecialModel = ref<boolean>(false);

const emits = __emit;

const selectInstitute = (institute: ItemSelect) => {
  selectedInstitute.value = institute;
}

const selectHealthPro = (healthPro: PersonLightResponse) => {
  selectedHealthPro.value = healthPro;
}

const setResfreshDataAppointmentType = (newValue: boolean) =>{
  refreshDataDayModel.value = newValue;
  emits('refresh-calendar', newValue);
}

const setResfreshDataSpecialAndWeekModel = (newValue: boolean) =>{
  refreshDataWeekAndSpecialModel.value = newValue;
  emits('refresh-calendar', newValue);
}

const setResfreshDataDayModel = (newValue: boolean) =>{
  refreshDataWeekAndSpecialModel.value = newValue;
  emits('refresh-calendar', newValue);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EsSelectInstitute, {
      "with-health-pro": true,
      onSelectInstitute: _cache[0] || (_cache[0] = ($event: any) => (selectInstitute($event))),
      onSelectHealthPro: _cache[1] || (_cache[1] = ($event: any) => (selectHealthPro($event))),
      class: "w-full",
      hasOwnerAgendaPermission: _ctx.hasOwnerAgendaPermission
    }, null, 8, ["hasOwnerAgendaPermission"]),
    (selectedHealthPro.value)
      ? (_openBlock(), _createBlock(Tabs, {
          key: 0,
          titles: [_unref(t)('settings.tab.main'), _unref(t)('settings.tab.appointmentTye'), _unref(t)('settings.tab.dayModel'),_unref(t)('settings.tab.specialDays'), _unref(t)('settings.tab.planning')],
          showCalendarHeader: false,
          "is-settings": true,
          class: "mtop-32px w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(Tab, {
              active: true,
              class: "mtop-08"
            }, {
              default: _withCtx(() => [
                _createVNode(EsCalendarMainSettings, {
                  selectedHealthPro: selectedHealthPro.value,
                  selectedInstitute: selectedInstitute.value,
                  onSetDuration: _cache[2] || (_cache[2] = ($event: any) => (duration.value = $event)),
                  onRefreshCalendar: _cache[3] || (_cache[3] = ($event: any) => (emits('refresh-calendar', true)))
                }, null, 8, ["selectedHealthPro", "selectedInstitute"])
              ]),
              _: 1
            }),
            _createVNode(Tab, { class: "mtop-08" }, {
              default: _withCtx(() => [
                _createVNode(EsAppointmentTypeSettings, {
                  selectedHealthPro: selectedHealthPro.value,
                  selectedInstituteId: selectedInstitute.value?.id,
                  baseAppointmentDuration: duration.value,
                  onAppointmentTypeChanged: _cache[4] || (_cache[4] = ($event: any) => (setResfreshDataAppointmentType(true)))
                }, null, 8, ["selectedHealthPro", "selectedInstituteId", "baseAppointmentDuration"])
              ]),
              _: 1
            }),
            _createVNode(Tab, { class: "mtop-08" }, {
              default: _withCtx(() => [
                _createVNode(EsDayModelSettings, {
                  selectedHealthPro: selectedHealthPro.value,
                  refreshData: refreshDataDayModel.value,
                  selectedInstituteId: selectedInstitute.value?.id ?? '',
                  onRefreshed: _cache[5] || (_cache[5] = ($event: any) => (setResfreshDataAppointmentType(false))),
                  onDayModelChanged: _cache[6] || (_cache[6] = ($event: any) => (setResfreshDataDayModel(true)))
                }, null, 8, ["selectedHealthPro", "refreshData", "selectedInstituteId"])
              ]),
              _: 1
            }),
            _createVNode(Tab, { class: "mtop-08" }, {
              default: _withCtx(() => [
                _createVNode(EsSpecialDaysSettings, {
                  selectedHealthPro: selectedHealthPro.value,
                  selectedInstituteId: selectedInstitute.value?.id ?? '',
                  refreshData: refreshDataWeekAndSpecialModel.value,
                  onRefreshed: _cache[7] || (_cache[7] = ($event: any) => (setResfreshDataSpecialAndWeekModel(false))),
                  onSpecialDaysChanged: _cache[8] || (_cache[8] = ($event: any) => (setResfreshDataDayModel(true)))
                }, null, 8, ["selectedHealthPro", "selectedInstituteId", "refreshData"])
              ]),
              _: 1
            }),
            _createVNode(Tab, { class: "mtop-08" }, {
              default: _withCtx(() => [
                _createVNode(EsPlanningSettings, {
                  selectedHealthPro: selectedHealthPro.value,
                  selectedInstituteId: selectedInstitute.value?.id ?? '',
                  refreshData: refreshDataWeekAndSpecialModel.value,
                  onRefreshed: _cache[9] || (_cache[9] = ($event: any) => (setResfreshDataSpecialAndWeekModel(false))),
                  onWeekModelChanged: _cache[10] || (_cache[10] = ($event: any) => (emits('refresh-calendar', $event)))
                }, null, 8, ["selectedHealthPro", "selectedInstituteId", "refreshData"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["titles"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(t)('settings.calendar.noHealthPro')), 1))
  ], 64))
}
}

})